import React from 'react';
import { UserCircle, Shield, Key, Smartphone, Save } from 'lucide-react';
export const AdminProfile = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-468">
      <div data-id="element-469">
        <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-470">
          Admin Profile
        </h1>
        <p className="text-slate-500 dark:text-slate-400" data-id="element-471">
          Manage your personal admin account settings.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6" data-id="element-472">
        {/* Left Col: Profile Card */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6 h-fit text-center" data-id="element-473">
          <div className="w-24 h-24 rounded-full bg-secondary/20 text-secondary flex items-center justify-center mx-auto mb-4 border-2 border-secondary/30" data-id="element-474">
            <UserCircle size={48} data-id="element-475" />
          </div>
          <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-1" data-id="element-476">
            Super Admin
          </h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-4" data-id="element-477">
            admin@amu.ng
          </p>
          <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400 text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-478">
            Full Access
          </span>
        </div>

        {/* Right Col: Settings */}
        <div className="lg:col-span-2 space-y-6" data-id="element-479">
          <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-480">
            <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-2" data-id="element-481">
              <UserCircle size={20} className="text-secondary" data-id="element-482" /> Personal
              Information
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-483">
              <div data-id="element-484">
                <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-485">
                  Full Name
                </label>
                <input type="text" defaultValue="Super Admin" className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none" data-id="element-486" />
              </div>
              <div data-id="element-487">
                <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-488">
                  Email Address
                </label>
                <input type="email" defaultValue="admin@amu.ng" className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none" data-id="element-489" />
              </div>
            </div>
            <div className="mt-6 flex justify-end" data-id="element-490">
              <button className="px-6 py-2 bg-secondary text-primary-900 font-bold rounded-xl flex items-center gap-2 hover:bg-secondary-dark transition-colors" data-id="element-491">
                <Save size={18} data-id="element-492" /> Save Changes
              </button>
            </div>
          </div>

          <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-493">
            <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-2" data-id="element-494">
              <Shield size={20} className="text-secondary" data-id="element-495" /> Security Settings
            </h3>

            <div className="space-y-6" data-id="element-496">
              <div className="flex items-center justify-between p-4 border border-slate-200 dark:border-slate-700 rounded-xl bg-slate-50 dark:bg-slate-800/50" data-id="element-497">
                <div className="flex items-center gap-4" data-id="element-498">
                  <div className="p-3 bg-white dark:bg-slate-700 rounded-lg text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-transparent" data-id="element-499">
                    <Key size={20} data-id="element-500" />
                  </div>
                  <div data-id="element-501">
                    <h4 className="font-bold text-slate-900 dark:text-white" data-id="element-502">
                      Password
                    </h4>
                    <p className="text-sm text-slate-500 dark:text-slate-400" data-id="element-503">
                      Last changed 30 days ago
                    </p>
                  </div>
                </div>
                <button className="px-4 py-2 bg-white dark:bg-slate-700 text-slate-900 dark:text-white text-sm font-bold rounded-lg hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors border border-slate-200 dark:border-transparent" data-id="element-504">
                  Update
                </button>
              </div>

              <div className="flex items-center justify-between p-4 border border-slate-200 dark:border-slate-700 rounded-xl bg-slate-50 dark:bg-slate-800/50" data-id="element-505">
                <div className="flex items-center gap-4" data-id="element-506">
                  <div className="p-3 bg-white dark:bg-slate-700 rounded-lg text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-transparent" data-id="element-507">
                    <Smartphone size={20} data-id="element-508" />
                  </div>
                  <div data-id="element-509">
                    <h4 className="font-bold text-slate-900 dark:text-white" data-id="element-510">
                      Two-Factor Authentication
                    </h4>
                    <p className="text-sm text-slate-500 dark:text-slate-400" data-id="element-511">
                      Authenticator app configured
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400 text-xs font-bold rounded uppercase" data-id="element-512">
                  Enabled
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};